module Sm.Core.Interop

open Fable.Core.JS
open Fable.Core.JsInterop

open Sm.Core.Text

let inline objectEntries o =
    if jsTypeof o = "object" then 
        Constructors.Object.entries o 
        |> seq
    else Seq.empty

let inline arrayEntries o =
    if Constructors.Array.isArray(o) then
        unbox<obj array> o
    else
        [||]

module RawObject =
    let inline get (name: string) (o: obj) =
        emitJsExpr<obj option> (o, name) "$0[$1]"

module Operators =
    let inline ( @ ) o n = 
        RawObject.get n o

    let inline ( @.. ) o n =
        RawObject.get n o
        |> Option.map arrayEntries
        |> Option.defaultValue [||]

module Number =
    let inline create x = emitJsExpr x "Number($0)"

module BigInt =
    let inline create x = emitJsExpr<int64> x "BigInt($0)"

module Json =
    let inline stringify x = JSON.stringify(x)

    let parseArray text: obj array =
        let x = JSON.parse(text)
        arrayEntries x

let inline (|JsArray|_|) (o: obj) =
    if Constructors.Array.isArray(o) then
        Some (unbox<obj array> o)
    else
        None

let inline (|JsString|_|) (o: obj) =
    if jsTypeof o = "string" then Some (unbox<string> o)
    else None

let inline (|JsNumber|_|) (o: obj) =
    if jsTypeof o = "number" then Some (unbox<float> o)
    else None

let inline (|JsGuid|_|) (o: obj) =
    match o with
    | JsString (Guid g) -> Some g
    | _ -> None
